export default __webpack_public_path__ + "static/media/cavemenClashing.bf99c4e1.png";